/**
 * Funding stages ("Förderstufen") of the Cassiopeia campaign.
 *
 * A stage says: reaching `threshold` votes unlocks `increment` euro of funding. The text that goes
 * with a stage (`fundingMessage`) stays in the app — it renders JSX.
 */
/**
 * Sorts the stages ascending by threshold without mutating the input.
 *
 * @param fundingData Configured stages.
 * @returns A new, sorted array; `[]` for missing input.
 */
export const sortFundingStages = (fundingData = []) => [...fundingData].sort((stageA, stageB) => stageA.threshold - stageB.threshold);
/**
 * Scales the current vote count onto the progress bar.
 *
 * @param currentVote    Votes of the project.
 * @param finalThreshold Threshold of the last funding stage.
 * @returns The progress in percent, `0` when there is nothing to scale and capped at `100`.
 */
export const scaleVotesToProgress = (currentVote, finalThreshold) => {
    let scaledProgress = 0;
    if (finalThreshold > 0 && currentVote > 0) {
        // use value of votes to scale progress according to last threshold and progress range
        scaledProgress = (currentVote * 100) / finalThreshold;
        // if current vote is greater than last threshold.
        if (scaledProgress > 100) {
            scaledProgress = 100;
        }
    }
    return scaledProgress;
};
/**
 * Finds the next stage the project has not reached yet.
 *
 * @param voteCount    Votes of the project.
 * @param fundingStages Configured stages.
 * @returns Index of the stage with the lowest threshold above `voteCount`, `-1` when fully funded.
 */
export const findNextFundingStageIndex = (voteCount, fundingStages) => {
    let upcomingThreshold = Infinity;
    let upcomingThresholdIndex = -1;
    for (let i = 0; i < fundingStages.length; i++) {
        const { threshold } = fundingStages[i];
        if (threshold > voteCount && threshold < upcomingThreshold) {
            upcomingThreshold = threshold;
            upcomingThresholdIndex = i;
        }
    }
    return upcomingThresholdIndex;
};
//# sourceMappingURL=funding-stages.js.map